module.exports = __webpack_public_path__ + "img/CUI.d883e6fe.png";